import { render } from "./ProsesLokasiAbsensi.vue?vue&type=template&id=8b1ed17c"
import script from "./ProsesLokasiAbsensi.vue?vue&type=script&lang=js"
export * from "./ProsesLokasiAbsensi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__